export interface Action<E, T> {
  type: E;
  data?: any;
}

export enum ActionType {
  REQUEST_START,
  REQUEST_END,

  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,

  AUTH_MANAGER_SET,
  AUTH_SIGNED_IN,
  AUTH_SIGNED_OUT,
  AUTH_GET_CURRENT_USER_PERMISSIONS,

  SEARCH_MANAGER_FORM_UPDATED,
  SEARCH_MANAGER_FORM_RESET,

  SEARCH_MANAGER_DATA_FETCHED,
  SEARCH_MANAGER_DATA_UPDATED,
  SEARCH_MANAGER_DATA_REFRESHED,
  SEARCH_MANAGER_DATA_LIST_ROW_DELETED,

  SEARCH_MANAGER_RULE_DATA_FETCHED,
  SEARCH_MANAGER_RULE_DATA_COPIED,
  SEARCH_MANAGER_RULE_DATA_UPDATED,
  SEARCH_MANAGER_RULE_DATA_VALIDATED,
  SEARCH_MANAGER_RULE_DATA_SAVED,
  SEARCH_MANAGER_RULE_DATA_RESET,
  SEARCH_MANAGER_RULE_DATA_SET_BRAND_AND_MARKET,

  SEARCH_MANAGER_RULE_SEARCHES_FORM_UPDATED,
  SEARCH_MANAGER_RULE_SEARCHES_FORM_RESET,

  SEARCH_MANAGER_RULE_SEARCHES_RESULTS_FETCHED,
  SEARCH_MANAGER_RULE_SEARCHES_RESULTS_UPDATED,
  SEARCH_MANAGER_RULE_SEARCHES_RESULTS_REFRESHED,
  SEARCH_MANAGER_RULE_SEARCHES_RESULTS_RESETED,
  SEARCH_MANAGER_RULE_SEARCHES_RESULTS_LIST_ROW_DELETED,

  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_DATA_FETCHED,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_UPDATED,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_RESET,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_WARNINGS_FETCHED,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_VALIDATED,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_SAVED,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_SET_BEFORE_SAVE,
  SEARCH_MANAGER_RULE_ITEM_EDIT_FORM_CLEAR_WARNINGS,

  SEARCH_MANAGER_V2_FILTERS_UPDATED,
  SEARCH_MANAGER_V2_FILTERS_RESET,

  MARKUPS_V2_FILTERS_UPDATED,
  MARKUPS_V2_FILTERS_RESET,

  MARKUPS_V2_TABLE_DATA_FETCHED,
  MARKUPS_V2_TABLE_DATA_KEYS_ENABLED,
  MARKUPS_V2_TABLE_DATA_KEYS_DELETED,

  //GLOBAL FILTERS V2
  GLOBAL_FILTERS_V2_FILTERS_UPDATED,
  GLOBAL_FILTERS_V2_FILTERS_RESET,

  GLOBAL_FILTERS_V2_TABLE_DATA_FETCHED,
  GLOBAL_FILTERS_V2_TABLE_DATA_KEYS_ENABLED,
  GLOBAL_FILTERS_V2_TABLE_DATA_KEYS_DELETED,

  GLOBAL_FILTERS_V2_EDITOR_DATA_FETCHED,
  GLOBAL_FILTERS_V2_EDITOR_DATA_COPIED,
  GLOBAL_FILTERS_V2_EDITOR_DATA_UPDATED,
  GLOBAL_FILTERS_V2_EDITOR_DATA_RESET,
  GLOBAL_FILTERS_V2_EDITOR_DATA_VALIDATED,
  GLOBAL_FILTERS_V2_EDITOR_DATA_SAVED,
  GLOBAL_FILTERS_V2_EDITOR_SET_BOUND_ITEM,
  GLOBAL_FILTERS_V2_EDITOR_DATA_SET_SELECTED_ROWS,

  //TTLO V2
  TTLO_V2_FILTERS_UPDATED,
  TTLO_V2_FILTERS_RESET,

  TTLO_V2_TABLE_DATA_FETCHED,
  TTLO_V2_TABLE_DATA_KEYS_ENABLED,
  TTLO_V2_TABLE_DATA_KEYS_DELETED,

  TTLO_V2_EDITOR_DATA_FETCHED,
  TTLO_V2_EDITOR_DATA_COPIED,
  TTLO_V2_EDITOR_DATA_UPDATED,
  TTLO_V2_EDITOR_DATA_RESET,
  TTLO_V2_EDITOR_DATA_VALIDATED,
  TTLO_V2_EDITOR_DATA_SAVED,
  TTLO_V2_EDITOR_SET_BOUND_ITEM,
  TTLO_V2_EDITOR_DATA_SET_SELECTED_ROWS,

  SEARCH_MANAGER_V2_TABLE_DATA_FETCHED,
  SEARCH_MANAGER_V2_TABLE_DATA_KEYS_ENABLED,
  SEARCH_MANAGER_V2_TABLE_DATA_KEYS_DELETED,

  SEARCH_MANAGER_V2_EDITOR_DATA_SET_SELECTED_ROWS,
  SEARCH_MANAGER_V2_EDITOR_DATA_SET_DISABLED_ROWS,
  SEARCH_MANAGER_V2_EDITOR_DATA_SET_ENABLE_ROWS,

  SEARCH_MANAGER_V2_EDITOR_DATA_FETCHED,
  SEARCH_MANAGER_V2_EDITOR_DATA_COPIED,
  SEARCH_MANAGER_V2_EDITOR_DATA_UPDATED,
  SEARCH_MANAGER_V2_EDITOR_DATA_RESET,
  SEARCH_MANAGER_V2_EDITOR_DATA_SAVED,
  SEARCH_MANAGER_V2_EDITOR_DATA_VALIDATED,
  SEARCH_MANAGER_V2_EDITOR_SET_BOUND_ITEM,

  SEARCH_MANAGER_V2_SEARCHES_FORM_UPDATED,
  SEARCH_MANAGER_V2_SEARCHES_FORM_RESET,

  SEARCH_MANAGER_V2_SEARCHES_RESULTS_FETCHED,
  SEARCH_MANAGER_V2_SEARCHES_RESULTS_UPDATED,
  SEARCH_MANAGER_V2_SEARCHES_RESULTS_REFRESHED,
  SEARCH_MANAGER_V2_SEARCHES_RESULTS_RESETED,
  SEARCH_MANAGER_V2_SEARCHES_RESULTS_LIST_ROW_DELETED,

  SEARCH_MANAGER_V2_SUBRULE_CONFIG_FETCHED,
  SEARCH_MANAGER_V2_SUBRULE_EDIT_DATA_FETCHED,
  SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_SAVED,
  SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_VALIDATED,
  SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_WARNINGS,
  SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_RESET,
  SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_UPDATED,
  SEARCH_MANAGER_V2_SUBRULE_TABLE_DATA_KEYS_ENABLED,
  SEARCH_MANAGER_V2_SUBRULE_DATA_SET_SELECTED_ROWS,
  SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_SAVED,
  SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_VALIDATED,
  SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_UPDATED,
  SEARCH_MANAGER_V2_SUBRULE_BULK_EDITOR_DATA_RESET,

  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_FORM_UPDATED,
  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_FORM_RESET,

  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_FETCHED,
  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_UPDATED,
  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_REFRESHED,
  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_CLEARED,
  SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_LIST_ROW_DELETED,

  SHOPPING_DIAGNOSTICS_FORM_IDENTETY_VALIDATED,
  SHOPPING_DIAGNOSTICS_FORM_AVAILABILITY_UPDATED,
  SHOPPING_DIAGNOSTICS_FORM_SIMULATEDINSTANT_UPDATED,
  SHOPPING_DIAGNOSTICS_FORM_IDENTITY_UPDATED,
  SHOPPING_DIAGNOSTICS_FORM_IDENTITY_UPDATED_HISTORICAL,
  SHOPPING_DIAGNOSTICS_CORRELATION_ID_UPDATED,
  SHOPPING_DIAGNOSTICS_HISTORICAL_CORRELATION_ID_UPDATED,
  SHOPPING_DIAGNOSTICS_FORM_DATA_VALIDATED,
  SHOPPING_DIAGNOSTICS_HISTORICAL_DATA_VALIDATED,
  SHOPPING_DIAGNOSTICS_FORM_RESET,
  SHOPPING_DIAGNOSTICS_HISTORICAL_FORM_RESET,

  SHOPPING_DIAGNOSTICS_DATA_FETCHED,
  SHOPPING_DIAGNOSTICS_DATA_FETCHED_HISTORICAL,
  SHOPPING_DIAGNOSTICS_DATA_LIST_ROW_DELETED,

  SHOPPING_DIAGNOSTICS_DATA_RESET_HISTORICAL,
  SHOPPING_DIAGNOSTICS_DATA_RESET_LIVE,

  SHOPPING_DIAGNOSTICS_EXCEPTIONS_FORM_UPDATED,
  SHOPPING_DIAGNOSTICS_EXCEPTIONS_FORM_RESET,

  SHOPPING_DIAGNOSTICS_EXCEPTIONS_DATA_FETCHED,
  SHOPPING_DIAGNOSTICS_EXCEPTIONS_DATA_UPDATED,
  SHOPPING_DIAGNOSTICS_EXCEPTIONS_DATA_REFRESHED,
  SHOPPING_DIAGNOSTICS_EXCEPTIONS_DATA_CLEARED,
  SHOPPING_DIAGNOSTICS_EXCEPTIONS_DATA_LIST_ROW_DELETED,

  BOOKING_DIAGNOSTICS_FORM_UPDATED,
  BOOKING_DIAGNOSTICS_FORM_IDENTITY_UPDATED,
  BOOKING_DIAGNOSTICS_FORM_RESET,
  BOOKING_DIAGNOSTICS_DATA_FETCHED,
  BOOKING_DIAGNOSTICS_DATA_RESET,
  BOOKING_DIAGNOSTICS_LOGS_FETCHED,

  BOOKING_CREATE_MANAGER_FORM_UPDATED,
  BOOKING_CREATE_MANAGER_FORM_RESET,

  BOOKING_CREATE_MANAGER_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_DATA_REFRESHED,
  BOOKING_CREATE_MANAGER_DATA_LIST_ROW_DELETED,

  BOOKING_CREATE_MANAGER_RULE_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_RULE_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_RULE_DATA_VALIDATED,
  BOOKING_CREATE_MANAGER_RULE_DATA_SAVED,
  BOOKING_CREATE_MANAGER_RULE_DATA_RESET,
  BOOKING_CREATE_MANAGER_RULE_DATA_SET_BRAND_AND_MARKET,

  BOOKING_CREATE_MANAGER_REMARKS_FORM_UPDATED,
  BOOKING_CREATE_MANAGER_REMARKS_FORM_RESET,

  BOOKING_CREATE_MANAGER_REMARKS_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_REMARKS_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_REMARKS_DATA_REFRESHED,
  BOOKING_CREATE_MANAGER_REMARKS_DATA_LIST_ROW_DELETED,

  BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_VALIDATED,
  BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_SAVED,
  BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_RESET,
  BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_SET_BRAND_AND_MARKET,

  BOOKING_CREATE_MANAGER_SSR_FILTERS_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_SSR_FILTERS_DATA_RESET,

  BOOKING_CREATE_MANAGER_SSR_TABLE_DATA_FETCHED,

  BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_COPIED,
  BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_RESET,
  BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_SAVED,
  BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_VALIDATED,
  BOOKING_CREATE_MANAGER_SSR_EDITOR_SET_BOUND_ITEM,

  BOOKING_CREATE_MANAGER_V2_FILTERS_UPDATED,
  BOOKING_CREATE_MANAGER_V2_FILTERS_RESET,

  BOOKING_CREATE_MANAGER_V2_TABLE_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_SET_SELECTED_ROWS,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_COPIED,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_RESET,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_SAVED,
  BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_VALIDATED,
  BOOKING_CREATE_MANAGER_V2_EDITOR_SET_BOUND_ITEM,
  BOOKING_CREATE_MANAGER_V2_TABLE_DATA_KEYS_ENABLED,
  BOOKING_CREATE_MANAGER_V2_TABLE_DATA_KEYS_DELETED,
  BOOKING_CREATE_MANAGER_V2_TABLE_DATA_UPDATED,

  BOOKING_CREATE_MANAGER_V2_REMARKS_TABLE_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_TABLE_DATA_ROW_DELETED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_FILTERS_UPDATED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_FILTERS_RESET,
  BOOKING_CREATE_MANAGER_V2_REMARKS_TABLE_DATA_KEYS_ENABLED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_TABLE_DATA_KEYS_DELETED,

  BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_RESET,
  BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_SAVED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_VALIDATED,
  BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_ROW_DELETED,

  BOOKING_CREATE_MANAGER_V2_SSR_FILTERS_UPDATED,
  BOOKING_CREATE_MANAGER_V2_SSR_FILTERS_RESET,

  BOOKING_CREATE_MANAGER_V2_SSR_TABLE_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_V2_SSR_TABLE_DATA_KEYS_ENABLED,
  BOOKING_CREATE_MANAGER_V2_SSR_TABLE_DATA_KEYS_DELETED,
  BOOKING_CREATE_MANAGER_V2_SSR_TABLE_DATA_ROW_DELETED,

  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_DATA_RESET,
  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_DATA_FETCHED,
  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_DATA_COPIED,
  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_DATA_UPDATED,
  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_DATA_SAVED,
  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_DATA_VALIDATED,
  BOOKING_CREATE_MANAGER_V2_SSR_EDITOR_SET_BOUND_ITEM,

  REGIONS_FORM_UPDATED,
  REGIONS_FORM_RESET,

  REGIONS_DATA_FETCHED,

  REGIONS_EDITOR_DATA_FETCHED,
  REGIONS_EDITOR_DATA_COPIED,
  REGIONS_EDITOR_DATA_UPDATED,
  REGIONS_EDITOR_DATA_RESET,
  REGIONS_EDITOR_DATA_SAVED,
  REGIONS_EDITOR_DATA_VALIDATED,

  COUNTRIES_FORM_UPDATED,
  COUNTRIES_FORM_RESET,

  COUNTRIES_DATA_FETCHED,

  COUNTRIES_EDITOR_DATA_FETCHED,
  COUNTRIES_EDITOR_DATA_COPIED,
  COUNTRIES_EDITOR_DATA_UPDATED,
  COUNTRIES_EDITOR_DATA_RESET,
  COUNTRIES_EDITOR_DATA_SAVED,
  COUNTRIES_EDITOR_DATA_VALIDATED,

  LOCATIONS_FORM_UPDATED,
  LOCATIONS_FORM_RESET,

  LOCATIONS_DATA_FETCHED,
  STATIONS_LOCATIONS_ALL_DATA_FETCHED,
  STATIONS_LOCATIONS_ALL_DATA_UPDATED,

  LOCATIONS_EDITOR_DATA_FETCHED,
  LOCATIONS_EDITOR_DATA_COPIED,
  LOCATIONS_EDITOR_DATA_UPDATED,
  LOCATIONS_EDITOR_DATA_RESET,
  LOCATIONS_EDITOR_DATA_SAVED,
  LOCATIONS_EDITOR_DATA_VALIDATED,

  STATIONS_FORM_UPDATED,
  STATIONS_FORM_RESET,

  STATIONS_DATA_FETCHED,

  STATIONS_EDITOR_DATA_FETCHED,
  STATIONS_EDITOR_DATA_COPIED,
  STATIONS_EDITOR_DATA_UPDATED,
  STATIONS_EDITOR_DATA_RESET,
  STATIONS_EDITOR_DATA_SAVED,
  STATIONS_EDITOR_DATA_VALIDATED,

  GEO_GROUPS_EDITOR_DATA_FETCHED,
  GEO_GROUPS_EDITOR_DATA_COPIED,
  GEO_GROUPS_EDITOR_DATA_UPDATED,
  GEO_GROUPS_EDITOR_DATA_RESET,
  GEO_GROUPS_EDITOR_DATA_SAVED,
  GEO_GROUPS_EDITOR_DATA_VALIDATED,
  GEO_GROUPS_EDITOR_SET_BOUND_ITEM,

  GEO_GROUPS_FILTERS_DATA_UPDATED,
  GEO_GROUPS_FILTERS_DATA_RESET,

  GEO_GROUPS_TABLE_DATA_FETCHED,

  SUPPLIER_TABLE_DATA_FETCHED,

  SUPPLIER_EDITOR_DATA_FETCHED,
  SUPPLIER_EDITOR_DATA_COPIED,
  SUPPLIER_EDITOR_DATA_UPDATED,
  SUPPLIER_EDITOR_DATA_RESET,
  SUPPLIER_EDITOR_DATA_SAVED,
  SUPPLIER_EDITOR_DATA_VALIDATED,
  SUPPLIER_EDITOR_SET_BOUND_ITEM,

  AIRLINES_FORM_UPDATED,
  AIRLINES_FORM_RESET,

  AIRLINES_DATA_FETCHED,
  AIRLINES_ALL_DATA_FETCHED,
  AIRLINES_ALL_DATA_UPDATED,

  AIRLINES_EDITOR_DATA_FETCHED,
  AIRLINES_EDITOR_DATA_COPIED,
  AIRLINES_EDITOR_DATA_UPDATED,
  AIRLINES_EDITOR_DATA_RESET,
  AIRLINES_EDITOR_DATA_SAVED,
  AIRLINES_EDITOR_DATA_VALIDATED,

  BRANDS_FORM_UPDATED,
  BRANDS_FORM_RESET,

  BRANDS_DATA_FETCHED,
  BRANDS_DATA_UPDATED,
  BRANDS_DATA_REFRESHED,

  BRANDS_EDITOR_DATA_FETCHED,
  BRANDS_EDITOR_DATA_COPIED,
  BRANDS_EDITOR_DATA_UPDATED,
  BRANDS_EDITOR_DATA_RESET,
  BRANDS_EDITOR_DATA_SAVED,
  BRANDS_EDITOR_DATA_VALIDATED,

  MARKETS_FORM_UPDATED,
  MARKETS_FORM_RESET,

  MARKETS_DATA_FETCHED,
  MARKETS_DATA_UPDATED,
  MARKETS_DATA_REFRESHED,

  MARKETS_EDITOR_DATA_FETCHED,
  MARKETS_EDITOR_DATA_COPIED,
  MARKETS_EDITOR_DATA_UPDATED,
  MARKETS_EDITOR_DATA_RESET,
  MARKETS_EDITOR_DATA_SAVED,
  MARKETS_EDITOR_DATA_VALIDATED,

  DISTRIBUTION_CHANNELS_FORM_UPDATED,
  DISTRIBUTION_CHANNELS_FORM_RESET,

  DISTRIBUTION_CHANNELS_DATA_FETCHED,
  DISTRIBUTION_CHANNELS_DATA_UPDATED,
  DISTRIBUTION_CHANNELS_DATA_REFRESHED,
  // DISTRIBUTION_CHANNELS_DATA_LIST_ROW_DELETED,

  DISTRIBUTION_CHANNELS_EDITOR_DATA_FETCHED,
  DISTRIBUTION_CHANNELS_EDITOR_DATA_UPDATED,
  DISTRIBUTION_CHANNELS_EDITOR_DATA_VALIDATED,
  DISTRIBUTION_CHANNELS_EDITOR_DATA_SAVED,
  DISTRIBUTION_CHANNELS_EDITOR_DATA_RESET,
  DISTRIBUTION_CHANNELS_EDITOR_DATA_COPIED,

  DISTRIBUTION_CHANNELS_V2_EDITOR_DATA_FETCHED,
  AGENCIES_FORM_UPDATED,
  AGENCIES_FORM_RESET,

  AGENCIES_DATA_FETCHED,
  AGENCIES_DATA_UPDATED,
  AGENCIES_DATA_REFRESHED,
  AGENCIES_ALL_DATA_FETCHED,
  AGENCIES_ALL_DATA_UPDATED,

  AGENCIES_EDITOR_DATA_FETCHED,
  AGENCIES_EDITOR_DATA_COPIED,
  AGENCIES_EDITOR_DATA_UPDATED,
  AGENCIES_EDITOR_DATA_RESET,
  AGENCIES_EDITOR_DATA_SAVED,
  AGENCIES_EDITOR_DATA_VALIDATED,
  AGENCIES_EDITOR_DATA_SET_BRAND_AND_MARKET,

  AGENCY_GROUPS_FORM_UPDATED,
  AGENCY_GROUPS_FORM_RESET,

  AGENCY_GROUPS_DATA_FETCHED,
  AGENCY_GROUPS_DATA_UPDATED,
  AGENCY_GROUPS_DATA_REFRESHED,

  AGENCY_GROUPS_EDITOR_DATA_FETCHED,
  AGENCY_GROUPS_EDITOR_DATA_COPIED,
  AGENCY_GROUPS_EDITOR_DATA_UPDATED,
  AGENCY_GROUPS_EDITOR_DATA_RESET,
  AGENCY_GROUPS_EDITOR_DATA_SAVED,
  AGENCY_GROUPS_EDITOR_DATA_VALIDATED,
  AGENCY_GROUPS_EDITOR_DATA_SET_BRAND_AND_MARKET,

  PROVIDER_PREFERENCES_FORM_UPDATED,
  PROVIDER_PREFERENCES_FORM_RESET,

  PROVIDER_PREFERENCES_DATA_FETCHED,
  PROVIDER_PREFERENCES_DATA_UPDATED,

  PROVIDER_PREFERENCES_EDITOR_DATA_FETCHED,
  PROVIDER_PREFERENCES_EDITOR_DATA_COPIED,
  PROVIDER_PREFERENCES_EDITOR_DATA_UPDATED,
  PROVIDER_PREFERENCES_EDITOR_DATA_RESET,
  PROVIDER_PREFERENCES_EDITOR_DATA_SAVED,
  PROVIDER_PREFERENCES_EDITOR_DATA_VALIDATED,

  PROVIDER_CREDENTIALS_FORM_UPDATED,
  PROVIDER_CREDENTIALS_FORM_RESET,

  PROVIDER_CREDENTIALS_DATA_FETCHED,
  PROVIDER_CREDENTIALS_DATA_UPDATED,
  PROVIDER_CREDENTIALS_DATA_REFRESHED,

  PROVIDER_CREDENTIALS_EDITOR_DATA_FETCHED,
  PROVIDER_CREDENTIALS_EDITOR_DATA_COPIED,
  PROVIDER_CREDENTIALS_EDITOR_DATA_UPDATED,
  PROVIDER_CREDENTIALS_EDITOR_DATA_RESET,
  PROVIDER_CREDENTIALS_EDITOR_DATA_SAVED,
  PROVIDER_CREDENTIALS_EDITOR_DATA_VALIDATED,
  PROVIDER_CREDENTIALS_EDITOR_DATA_GET_PROVIDER,

  IDENTITY_PROVIDER_SETTINGS_FORM_UPDATED,
  IDENTITY_PROVIDER_SETTINGS_FORM_RESET,

  IDENTITY_PROVIDER_SETTINGS_DATA_UPDATED,
  IDENTITY_PROVIDER_SETTINGS_DATA_REFRESHED,
  IDENTITY_PROVIDER_SETTINGS_DATA_FETCHED,

  IDENTITY_PROVIDER_SETTINGS_EDITOR_PROVIDER_SET,
  IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_FETCHED,
  IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_COPIED,
  IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_UPDATED,
  IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_RESET,
  IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_SAVED,
  IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_VALIDATED,

  IDENTITY_SETTINGS_FORM_UPDATED,
  IDENTITY_SETTINGS_FORM_RESET,

  IDENTITY_SETTINGS_DATA_UPDATED,
  IDENTITY_SETTINGS_DATA_REFRESHED,
  IDENTITY_SETTINGS_DATA_FETCHED,

  IDENTITY_SETTINGS_EDITOR_BRAND_AND_MARKET_SET,
  IDENTITY_SETTINGS_EDITOR_DATA_FETCHED,
  IDENTITY_SETTINGS_EDITOR_DATA_COPIED,
  IDENTITY_SETTINGS_EDITOR_DATA_UPDATED,
  IDENTITY_SETTINGS_EDITOR_DATA_RESET,
  IDENTITY_SETTINGS_EDITOR_DATA_SAVED,
  IDENTITY_SETTINGS_EDITOR_DATA_VALIDATED,

  MARKUPS_FORM_UPDATED,
  MARKUPS_FORM_RESET,

  MARKUPS_DATA_FETCHED,
  MARKUPS_DATA_UPDATED,
  MARKUPS_DATA_REFRESHED,
  MARKUPS_DATA_LIST_ROW_DELETED,

  MARKUP_EDITOR_DATA_COPIED,
  MARKUP_EDITOR_DATA_FETCHED,
  MARKUP_EDITOR_DATA_VALIDATED,
  MARKUP_EDITOR_DATA_SAVED,
  MARKUP_EDITOR_DATA_UPDATED,
  MARKUP_EDITOR_DATA_RESET,
  MARKUP_EDITOR_DATA_SET_BRAND_AND_MARKET,

  MARKUP_V2_EDITOR_DATA_UPDATED,
  MARKUP_V2_EDITOR_DATA_RESET,
  MARKUP_V2_CONFIG_DATA_UPDATED,
  MARKUP_V2_EDITOR_DATA_SAVED,
  MARKUP_V2_EDITOR_DATA_COPIED,
  MARKUP_V2_EDITOR_DATA_FETCHED,
  MARKUP_V2_EDITOR_DATA_VALIDATED,

  TICKET_TLO_FORM_UPDATED,
  TICKET_TLO_FORM_RESET,

  TICKET_TLO_DATA_FETCHED,
  TICKET_TLO_DATA_UPDATED,
  TICKET_TLO_DATA_REFRESHED,

  TICKET_TLO_EDITOR_DATA_FETCHED,
  TICKET_TLO_EDITOR_DATA_COPIED,
  TICKET_TLO_EDITOR_DATA_UPDATED,
  TICKET_TLO_EDITOR_DATA_RESET,
  TICKET_TLO_EDITOR_DATA_SAVED,
  TICKET_TLO_EDITOR_DATA_VALIDATED,
  TICKET_TLO_EDITOR_DATA_SET_BRANDS_AND_MARKETS,

  GLOBAL_FILTERS_FORM_UPDATED,
  GLOBAL_FILTERS_FORM_RESET,

  GLOBAL_FILTERS_DATA_FETCHED,
  GLOBAL_FILTERS_DATA_UPDATED,
  GLOBAL_FILTERS_DATA_REFRESHED,

  GLOBAL_FILTERS_EDITOR_DATA_FETCHED,
  GLOBAL_FILTERS_EDITOR_DATA_COPIED,
  GLOBAL_FILTERS_EDITOR_DATA_UPDATED,
  GLOBAL_FILTERS_EDITOR_DATA_RESET,
  GLOBAL_FILTERS_EDITOR_DATA_SAVED,
  GLOBAL_FILTERS_EDITOR_DATA_VALIDATED,
  GLOBAL_FILTERS_EDITOR_DATA_SET_BRAND_AND_MARKET,

  USER_PERMISSIONS_FORM_UPDATED,
  USER_PERMISSIONS_FORM_RESET,

  USER_PERMISSIONS_DATA_UPDATED,
  USER_PERMISSIONS_DATA_REFRESHED,
  USER_PERMISSIONS_DATA_FETCHED,

  USER_PERMISSIONS_EDITOR_DATA_FETCHED,
  USER_PERMISSIONS_EDITOR_DATA_COPIED,
  USER_PERMISSIONS_EDITOR_DATA_UPDATED,
  USER_PERMISSIONS_EDITOR_DATA_RESET,
  USER_PERMISSIONS_EDITOR_DATA_SAVED,
  USER_PERMISSIONS_EDITOR_DATA_VALIDATED,
  USER_PERMISSIONS_EDITOR_VALIDATE_DATA_RESET,

  ACTIVITY_LOG_FORM_UPDATED,
  ACTIVITY_LOG_FORM_RESET,
  ACTIVITY_LOG_RESULTS_GET,
  ACTIVITY_LOG_RESULTS_RESET,

  ANCILLARIES_MAPPING_FILTERS_DATA_UPDATED,
  ANCILLARIES_MAPPING_FILTERS_DATA_RESET,
  ANCILLARIES_MAPPING_TABLE_DATA_FETCHED,

  ANCILLARIES_MANAGER_FILTERS_DATA_UPDATED,
  ANCILLARIES_MANAGER_FILTERS_DATA_RESET,
  ANCILLARIES_MANAGER_TABLE_DATA_FETCHED,

  ANCILLARIES_MANAGER_EDITOR_DATA_COPIED,
  ANCILLARIES_MANAGER_EDITOR_DATA_FETCHED,
  ANCILLARIES_MANAGER_EDITOR_DATA_SAVED,
  ANCILLARIES_MANAGER_EDITOR_DATA_VALIDATED,
  ANCILLARIES_MANAGER_EDITOR_DATA_UPDATED,
  ANCILLARIES_MANAGER_EDITOR_DATA_RESET,
  ANCILLARIES_MANAGER_EDITOR_SET_BOUND_ITEM,

  ANCILLARIES_MAPPING_EDITOR_DATA_FETCHED,
  ANCILLARIES_MAPPING_EDITOR_DATA_COPIED,
  ANCILLARIES_MAPPING_EDITOR_DATA_UPDATED,
  ANCILLARIES_MAPPING_EDITOR_DATA_RESET,
  ANCILLARIES_MAPPING_EDITOR_DATA_SAVED,
  ANCILLARIES_MAPPING_EDITOR_DATA_VALIDATED,
  ANCILLARIES_MAPPING_EDITOR_SET_BOUND_ITEM,

  ANCILLARIES_DISTRIBUTIONS_FILTERS_DATA_UPDATED,
  ANCILLARIES_DISTRIBUTIONS_FILTERS_DATA_RESET,

  ANCILLARY_DISTRIBUTION_EDITOR_DATA_FETCHED,
  ANCILLARY_DISTRIBUTION_EDITOR_DATA_COPIED,
  ANCILLARY_DISTRIBUTION_EDITOR_DATA_UPDATED,
  ANCILLARY_DISTRIBUTION_EDITOR_DATA_RESET,
  ANCILLARY_DISTRIBUTION_EDITOR_DATA_SAVED,
  ANCILLARY_DISTRIBUTION_EDITOR_DATA_VALIDATED,
  ANCILLARY_DISTRIBUTION_EDITOR_SET_BOUND_ITEM,

  ANCILLARY_DISTRIBUTION_TABLE_DATA_FETCHED,

  VCC_CREDENTIALS_FILTERS_DATA_UPDATED,
  VCC_CREDENTIALS_FILTERS_DATA_RESET,
  VCC_CREDENTIALS_TABLE_DATA_FETCHED,

  VCC_CREDENTIALS_EDITOR_DATA_FETCHED,
  VCC_CREDENTIALS_EDITOR_DATA_COPIED,
  VCC_CREDENTIALS_EDITOR_DATA_UPDATED,
  VCC_CREDENTIALS_EDITOR_DATA_RESET,
  VCC_CREDENTIALS_EDITOR_DATA_SAVED,
  VCC_CREDENTIALS_EDITOR_DATA_VALIDATED,
  VCC_CREDENTIALS_EDITOR_SET_BOUND_ITEM,

  BOOKING_TOLERANCES_FILTERS_DATA_UPDATED,
  BOOKING_TOLERANCES_FILTERS_DATA_RESET,
  BOOKING_TOLERANCES_TABLE_DATA_FETCHED,

  BOOKING_TOLERANCES_EDITOR_DATA_FETCHED,
  BOOKING_TOLERANCES_EDITOR_DATA_COPIED,
  BOOKING_TOLERANCES_EDITOR_DATA_UPDATED,
  BOOKING_TOLERANCES_EDITOR_DATA_RESET,
  BOOKING_TOLERANCES_EDITOR_DATA_SAVED,
  BOOKING_TOLERANCES_EDITOR_DATA_VALIDATED,
  BOOKING_TOLERANCES_EDITOR_SET_BOUND_ITEM,

  BUSINESS_DATA_RELEVANCES_UPDATED,
  BUSINESS_DATA_MARKUPTYPES_UPDATED,
  BUSINESS_DATA_BRAND_AND_MARKETS_UPDATED,
  BUSINESS_DATA_CABIN_TYPES_UPDATED,
  BUSINESS_DATA_JOURNEY_TYPES_UPDATED,

  MARKUP_V2_PRIORITIES_UPDATED,
  // Provider Credentials V2
  PROVIDER_CREDENTIALS_V2_FILTERS_UPDATED,
  PROVIDER_CREDENTIALS_V2_FILTERS_RESET,
  PROVIDER_CREDENTIALS_V2_TABLE_DATA_FETCHED,
  PROVIDER_CREDENTIALS_V2_TABLE_DATA_KEYS_ENABLED,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_RESET,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_FETCHED,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_COPIED,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_UPDATED,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_SAVED,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_VALIDATED,
  PROVIDER_CREDENTIALS_V2_EDITOR_SET_BOUND_ITEM,
  PROVIDER_CREDENTIALS_V2_EDITOR_DATA_SET_SELECTED_ROWS,
}
